import { h, Component } from 'preact'
import { Router } from 'preact-router'
import { Layout, Panel } from 'react-toolbox/lib/layout'
// import Home from './../routes/home'
// import Cigar from './../routes/cigar'
// import Accounts from './../routes/accounts/Accounts'
// import AccountDetails from './../routes/accountDetails/AccountDetails'

import Home from 'async!./../routes/home'
import Cigar from 'async!./../routes/cigar'
import Accounts from 'async!./../routes/accounts/Accounts'
import AccountDetails from 'async!./../routes/accountDetails/AccountDetails'

import Header from './header'
import NavDrawer from './navDrawer/NavDrawer'
import { coBrandLogin, memberLogin } from './../api/yodlee/yodlee'
import { setCoBrandToken, setUserSessionToken } from './../api/yodlee/actions'

class App extends Component {
  state = {
    drawerActive: false,
  }
  componentDidMount() {
    const { setCoBrandToken, setUserSessionToken } = this.props
    let cobSessionToken = null
    let userSessionToken = null
    coBrandLogin()
      .then(_cobSessionToken => {
        cobSessionToken = _cobSessionToken
        setCoBrandToken(cobSessionToken)
        return memberLogin(cobSessionToken)
      })
      .then(_userSessionToken => {
        userSessionToken = _userSessionToken
        setUserSessionToken(userSessionToken)
      })
  }

  /** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
  handleRoute = e => {
    this.currentUrl = e.url
  }
  toggleDrawerActive = () => {
    this.setState({ drawerActive: !this.state.drawerActive })
  }
  render() {
    return (
      <Layout>
        <NavDrawer
          active={this.state.drawerActive}
          onOverlayClick={this.toggleDrawerActive}
        />
        <Panel>
          <Header onLeftIconClick={this.toggleDrawerActive} />
          <main style={{ flex: 1, overflowY: 'auto', padding: '1rem' }}>
            <Router onChange={this.handleRoute}>
              <Home path="/" />
              <Cigar path="/cigar" />
              <Accounts path="/accounts" />
              <AccountDetails path="/accounts/:id" />
            </Router>
          </main>
        </Panel>
      </Layout>
    )
  }
}

import { connect } from 'preact-redux'

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setCoBrandToken: token => dispatch(setCoBrandToken(token)),
  setUserSessionToken: token => dispatch(setUserSessionToken(token)),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./components/app.js